import "./tabmenu.css";

export default function Tabmenu({ selectedTab, onTabChange }) {
  const tabs = [
    "SEARCH",
    "MODELS",
    "DOCUMENTS",
    "PARTS",
    "IMAGE",
    "PRICING",
    "PRICING RESULT",
  ];

  const handleTabClick = (tab) => {
    if (onTabChange) {
      onTabChange(tab);
    }
  };

  return (
    <div className="tabMenuContainer">
      {tabs.map((tab) => (
        <div
          key={tab}
          className={`tabItem ${selectedTab === tab ? "activeTab" : ""}`}
          onClick={() => handleTabClick(tab)}
        >
          {tab}
        </div>
      ))}
    </div>
  );
}
